import { HttpClient } from '@angular/common/http';
import { Injectable, NgZone } from '@angular/core';
import { environment } from '../../../../../../environments/environment.dev';
import { IAIStep, IAttachment, IDocumentVersion, IFile } from '../../../../../@core/models/model';
import { BaseService } from '../../../../../@core/services/base.service';
import { DOCUMENT_MODEL, EMBEDDINGS_GENERATION_STATUS, IContract, IDocumentCompare } from '../../../../models/contract-management.model';
import { IKpi } from '../../../../models/settings.model';
import { DOWNLOAD_AUDIT_LOGS_TYPE, KPI_MODE } from './compare-report-view/compare-report-view.component';

export type IDocumentCompareResponse = IDocumentCompare & {
    compareContracts: {
        _id: string,
        doc: (IContract | IFile | IDocumentVersion | IAttachment) & { attachment: { _id: string, url: string } },
        docModel: DOCUMENT_MODEL,
        embeddingsStatus: EMBEDDINGS_GENERATION_STATUS
    }[],
    kpis: {
        kpi: IKpi,
        comparison: IAttachment | string,
        messages: any,
        todos: any,
        generationTime: number,
        plan: string[] | IAIStep[]
        thoughts: string[]
    }[]
}
@Injectable({
    providedIn: 'root'
})

export class CompareService extends BaseService {

    private url = environment.apiUrl + '/compare'
    constructor(
        protected override http: HttpClient,
        protected ngZone: NgZone
    ) {
        super(http, ngZone);
    }

    // compareDocuments: string[]
    getCompareResult(data: { comparisonId: string, compareDocuments?: string }) {
        return this.stream<any>(this.url + '/compare-docs', data)
    }


    //kpi: { _id: string | null, name: string, description: string }
    // compareDocuments: string[]
    getCompareKpiResult(data: { comparisonId: string, documentsToBeCompared?: string[], linkedDocumentsToBeCompared?: string[] }) {
        return this.post<any>(this.url + '/compare-kpis-new', data)
    }

    downloadComparison(data: { comparisonId: string, showComplianceMatrix: boolean, showChart: boolean, showFullReport: boolean, kpiId: string, mode?: 'preview' | 'download' | 'open' }) {
        return this.post<{ data: Uint8Array }>(this.url + '/download-comparison', data)
    }

    getHistory(document: string) {
        return this.get<IDocumentCompare[]>(this.url + '/history', { document })
    }

    downloadCompareAuditLogs(data: { comparisonId: string, type: DOWNLOAD_AUDIT_LOGS_TYPE, kpiId?: string }) {
        return this.post<any>(this.url + '/download-audit-logs', data);
    }

    downloadKpi(kpiId: string, kpiName: string, comparisonId: string) {
        return this.post<any>(this.url + '/download-kpi', { kpiId, kpiName, comparisonId })
    }

    getComparison(compareId: string) {
        return this.get<IDocumentCompareResponse>(this.url + '/comparison', { compareId })
    }

    updateComparisonName(compareId: string, name: string) {
        return this.put<any>(this.url + '/update-comparison', { compareId, name })
    }
    deleteComparison(compareId: string) {
        return this.delete<any>(this.url + '/delete-comparison', { compareId })
    }

    createComparisonWithUploadedDocs(data: FormData) {
        return this.post<{ _id: string, name: string }>(this.url + '/create-comparison-with-uploaded-docs', data)
    }

    removeKpi(compareId: string, kpiId: string) {
        return this.delete<any>(this.url + '/delete-kpi', { compareId, kpiId })
    }

    generateKpi(data: { comparisonId: string, kpi: { _id?: string | null, name?: string, description?: string, mode: KPI_MODE }, }) {
        return this.post<any>(this.url + '/generate-kpi', data)
    }

    stopKpiGeneration(comparisonId: string, kpiId: string) {
        return this.post<any>(this.url + '/stop-kpi-generation', { comparisonId, kpiId })
    }
}
